import { CommonMessages } from "../messages/validationMessages"
import * as Yup from 'yup'

export const addPromotionSchema = Yup.object().shape({
    assignedlocation: Yup.string().required(CommonMessages.location_required),
    washname: Yup.string().required(CommonMessages.washname_required),
    promotionname: Yup.string().required(CommonMessages.promotionname_required),
    generatecode: Yup.string().required(CommonMessages.promocode_required),
    promotiondetails: Yup.string().required(CommonMessages.promotiondetails_required),
    discounttype: Yup.string().required(CommonMessages.discounttype_required),
    validFrom: Yup.string().required(CommonMessages.validFrom_required),
    validTo: Yup.string().required(CommonMessages.validTo_required),
    PromotionDuration: Yup.string().required(CommonMessages.promoDuration_required),
    discount_value: Yup.string().required(CommonMessages.discount_value_required),
})
